import { Component, ElementRef, ChangeDetectorRef, AfterViewInit, inject, input } from '@angular/core';

import { LoadingService } from '../../services';
import { BaseComponent } from '../base/base.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-loading',
  styleUrl: 'loading.component.scss',
  templateUrl: 'loading.component.html',
})
export class LoadingComponent extends BaseComponent implements AfterViewInit {
  private readonly loadingScreenService = inject(LoadingService);
  private readonly _elmRef = inject(ElementRef);
  private readonly _changeDetectorRef = inject(ChangeDetectorRef);

  public readonly static = input(false);

  ngAfterViewInit(): void {
    this._elmRef.nativeElement.style.display = 'none';
    this.loadingScreenService.loading$.pipe(takeUntil(this.destroy$)).subscribe((status: boolean) => {
      this._elmRef.nativeElement.style.display = status ? 'block' : 'none';
      this._changeDetectorRef.detectChanges();
    });
  }
}
